import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';


@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileSubscriptionApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_subscriptions';
 

  addReferral(organisationProfileId:string){
    const body = {
      "organisationProfile": "/organisation_profiles/"+organisationProfileId
    }
    return this.http.post<any>(this.resourceUrl+'/from_referral',body);
  }

  disableAutoRenewal(id:string){
    return this.http.post<any>(this.resourceUrl+'/'+id+'/disable_auto_renew',{});
  }
  enableAutoRenewal(id:string){
    return this.http.post<any>(this.resourceUrl+'/'+id+'/enable_auto_renew',{});
  }
}
